import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9771b920"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["role", "aria-live"]
const _hoisted_2 = { class: "content flex" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm font-semibold block mb-1"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ri-close-fill ml-2.5",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    role: _ctx.setToastStatus,
    "aria-atomic": "true",
    "aria-live": _ctx.setToastAriaLive,
    class: _normalizeClass(["toast bounce-in-right opacity-100", _ctx.setToastType]),
    ref: "toastItem"
  }, [
    _createElementVNode("section", _hoisted_2, [
      (_ctx.hasIcon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(["mr-2.5", _ctx.setToastIconClass])
          }, null, 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
      ]),
      (_ctx.hasCloseButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "flex close-toast",
            "aria-label": "Close message",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeToast && _ctx.closeToast(...args)))
          }, _hoisted_5))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}